export default __webpack_public_path__ + "static/media/532.69a1f9c1.svg";